/* Softech AI Solution Finder (batch 4, Sep 2026; SEO guard 29 Sep).
   The page HTML holds only empty, labelled slots (.saf-slot[data-saf-slot]) with reserved height.
   This deferred script builds each advisor client-side when its slot comes within 600 px of the viewport,
   loading the stylesheet first. No heading tags, no crawlable links (the cart link gets its href only after an answer).
   All model output is rendered with textContent. GA4 events: ai_finder_ask, ai_finder_answer, ai_finder_add_to_cart, generate_lead. */
(function () {
  if (window.__safLoaded) return; window.__safLoaded = true;

  var cssPromise = null;
  function loadCss(href) {
    if (cssPromise) return cssPromise;
    cssPromise = new Promise(function (resolve) {
      if (!href) { resolve(); return; }
      var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = href;
      l.onload = resolve; l.onerror = resolve; document.head.appendChild(l);
      setTimeout(resolve, 3000);
    });
    return cssPromise;
  }
  function track(brand, name, params) {
    try {
      params = params || {}; params.brand = brand;
      if (window.gtag) { window.gtag('event', name, params); }
      else { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, params)); }
    } catch (e) {}
  }
  function el(tag, text, cls) { var e = document.createElement(tag); if (text != null) e.textContent = text; if (cls) e.className = cls; return e; }
  function money(n) { return '$' + Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }

  var FORM = '' +
    '<form class="saf-ask" autocomplete="off">' +
      '<label class="saf-lbl">Your question or requirement</label>' +
      '<textarea class="saf-q" maxlength="800" required></textarea>' +
      '<button type="submit" class="saf-btn">Get recommendation</button>' +
      '<p class="saf-note">Answers use official vendor documentation and forums. Prices come from this store.</p>' +
    '</form>' +
    '<div class="saf-status" role="status" aria-live="polite"></div>' +
    '<div class="saf-out" hidden>' +
      '<div class="saf-answer"></div><ul class="saf-sources"></ul>' +
      '<div class="saf-boq" hidden>' +
        '<div class="saf-sub-h">Suggested bill of materials</div>' +
        '<table><thead><tr><th>Item</th><th>Qty</th><th>Unit</th><th>Total</th></tr></thead><tbody></tbody>' +
        '<tfoot><tr><td colspan="3">Estimated total (USD, before tax)</td><td class="saf-total"></td></tr></tfoot></table>' +
        '<div class="saf-actions"><a class="saf-btn saf-cart" rel="nofollow">Add all to cart</a>' +
        '<button type="button" class="saf-btn saf-alt saf-open-lead">Email me this as a formal quote</button></div>' +
      '</div>' +
      '<button type="button" class="saf-link saf-open-lead saf-nolines" hidden>Talk to an engineer about this</button>' +
      '<form class="saf-lead" hidden>' +
        '<div class="saf-sub-h">Get a formal quote</div>' +
        '<div class="saf-grid">' +
          '<label>Full name *<input name="name" required maxlength="120" autocomplete="name"></label>' +
          '<label>Company *<input name="company" required maxlength="160" autocomplete="organization"></label>' +
          '<label>Work email *<input name="email" type="email" required autocomplete="email" placeholder="name@company.com"></label>' +
          '<label>Phone with country code *<input name="phone" type="tel" required inputmode="tel" pattern="^\\+?[0-9][0-9 ()\\-]{6,23}$" placeholder="+1 202 555 0100">' +
          '<small>e.g. +1 202 555 0100 or +971 50 123 4567</small></label>' +
        '</div>' +
        '<button type="submit" class="saf-btn">Send my quote request</button>' +
        '<p class="saf-lead-msg" role="status" aria-live="polite"></p>' +
      '</form>' +
    '</div>';

  function build(slot) {
    var d = slot.dataset, compact = d.compact === '1', uid = d.uid || 'main';
    var box = el('div', null, 'saf' + (compact ? ' saf--compact' : ''));
    box.setAttribute('data-api', d.api || ''); box.setAttribute('data-brand', d.brand || '');
    var inner = el('div', null, 'saf-in');
    var host = inner;
    if (compact) {
      var det = el('details', null, 'saf-compact'); var sum = el('summary', d.heading, 'saf-h');
      det.appendChild(sum); inner.appendChild(det); host = det;
    } else {
      inner.appendChild(el('div', d.heading, 'saf-h'));
      if (d.intro) inner.appendChild(el('p', d.intro, 'saf-sub'));
    }
    var wrap = document.createElement('div'); wrap.innerHTML = FORM;
    while (wrap.firstChild) host.appendChild(wrap.firstChild);
    box.appendChild(inner);
    var ta = box.querySelector('.saf-q'); ta.id = 'saf-q-' + uid; ta.rows = compact ? 2 : 3; ta.placeholder = d.placeholder || '';
    box.querySelector('.saf-lbl').setAttribute('for', ta.id);
    slot.appendChild(box);
    wire(box);
  }

  function wire(root) {
    var API = root.dataset.api, BRAND = root.dataset.brand || '';
    var q = root.querySelector('.saf-q'), status = root.querySelector('.saf-status'), out = root.querySelector('.saf-out');
    var last = null;

    root.querySelector('.saf-ask').addEventListener('submit', function (ev) {
      ev.preventDefault();
      if (!API) { status.textContent = 'The advisor is being set up. Please use the quote form.'; return; }
      status.textContent = 'Checking vendor documentation and our catalog...'; out.hidden = true; track(BRAND, 'ai_finder_ask');
      fetch(API + '/api/ask', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ question: q.value.trim(), brand: BRAND, page: location.href }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.detail || 'Request failed'); return j; }); })
        .then(function (d) {
          last = { question: q.value.trim(), data: d }; status.textContent = '';
          var a = root.querySelector('.saf-answer'); a.textContent = '';
          (d.answer || '').split(/\n{2,}/).forEach(function (par) { if (par.trim()) a.appendChild(el('p', par.replace(/\*\*/g, '').trim())); });
          var src = root.querySelector('.saf-sources'); src.textContent = '';
          (d.sources || []).forEach(function (s) { var li = el('li'); var l = el('a', s.title); l.href = s.url; l.target = '_blank'; l.rel = 'noopener nofollow'; li.appendChild(l); src.appendChild(li); });
          var boq = root.querySelector('.saf-boq'), tb = boq.querySelector('tbody'); tb.textContent = '';
          if ((d.boq || []).length) {
            d.boq.forEach(function (b) {
              var tr = el('tr'); var td = el('td'); var l = el('a', b.product + (b.option && b.option !== 'Default Title' ? ' - ' + b.option : '')); l.href = b.url; l.rel = 'nofollow'; td.appendChild(l);
              if (b.why) { td.appendChild(el('small', b.why)); }
              tr.appendChild(td); tr.appendChild(el('td', String(b.qty))); tr.appendChild(el('td', money(b.unit_price))); tr.appendChild(el('td', money(b.line_total))); tb.appendChild(tr);
            });
            boq.querySelector('.saf-total').textContent = money(d.total);
            boq.querySelector('.saf-cart').href = d.cart_url; boq.hidden = false; root.querySelector('.saf-nolines').hidden = true;
          } else { boq.hidden = true; root.querySelector('.saf-nolines').hidden = false; }
          out.hidden = false;
          track(BRAND, 'ai_finder_answer', { boq_lines: (d.boq || []).length, value: d.total || 0, currency: 'USD' });
          try { sessionStorage.setItem('softech_rec', (d.boq || []).map(function (b) { return b.product + ' x' + b.qty; }).join('; ')); } catch (e) {}
        })
        .catch(function (err) { status.textContent = err.message + ' You can also use the quote form below.'; });
    });

    root.querySelector('.saf-cart').addEventListener('click', function () { track(BRAND, 'ai_finder_add_to_cart', { value: last && last.data ? last.data.total : 0, currency: 'USD' }); });
    root.querySelectorAll('.saf-open-lead').forEach(function (b) { b.addEventListener('click', function () { var f = root.querySelector('.saf-lead'); f.hidden = false; f.querySelector('input').focus(); }); });

    root.querySelector('.saf-lead').addEventListener('submit', function (ev) {
      ev.preventDefault(); var f = ev.target, msg = f.querySelector('.saf-lead-msg'); msg.textContent = 'Sending...';
      var d = last ? last.data : {};
      fetch(API + '/api/lead', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({
        name: f.name.value, company: f.company.value, email: f.email.value, phone: f.phone.value,
        question: last ? last.question : '', answer: d.answer || '', page: location.href,
        boq: (d.boq || []).map(function (b) { return { variant_id: b.variant_id, qty: b.qty }; }) }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.detail ? (typeof j.detail === 'string' ? j.detail : 'Please check the phone and email fields.') : 'Request failed'); return j; }); })
        .then(function () { track(BRAND, 'generate_lead', { source: 'ai_finder', value: d.total || 0, currency: 'USD' }); msg.textContent = 'Received. An engineer will email your formal quote within one business day.'; f.querySelector('button').disabled = true; })
        .catch(function (err) { msg.textContent = err.message; });
    });
  }

  function activate(slot) {
    if (slot.dataset.safReady) return; slot.dataset.safReady = '1';
    loadCss(slot.dataset.css).then(function () { build(slot); });
  }
  function scan() {
    var slots = document.querySelectorAll('.saf-slot[data-saf-slot]');
    if (!('IntersectionObserver' in window)) { slots.forEach(activate); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting && e.target.offsetParent !== null) { io.unobserve(e.target); activate(e.target); } });
    }, { rootMargin: '600px 0px' });
    slots.forEach(function (s) { if (!s.dataset.safReady) io.observe(s); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
  // hero buttons that jump to #ai-finder: build it at once so the jump lands on the advisor
  window.addEventListener('hashchange', function () { var s = document.getElementById(location.hash.slice(1)); if (s && s.matches('.saf-slot')) activate(s); });
})();
